import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { emit } from "@/lib/events";
import ProductCard from "@/components/store/ProductCard";

export default function SearchResults() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!q.trim()) { setData({ items: [], total: 0 }); return; }
    setData(null);
    document.title = `Search: ${q} | Siyaara`;
    emit("search", { search_term: q });
    api.get("/search", { params: { q, limit: 60 } }).then((r) => setData(r.data)).catch(() => setData({ items: [], total: 0 }));
  }, [q]);

  return (
    <div className="container-x py-8" data-testid="search-page">
      <p className="eyebrow">SEARCH</p>
      <h1 className="font-heading text-3xl font-semibold mt-1" data-testid="search-title">
        {q ? <>Results for “{q}”</> : "Search Siyaara"}
      </h1>
      {!data ? (
        <p className="text-sm font-mono text-ink-2 mt-8">SEARCHING…</p>
      ) : (
        <>
          {data.corrected && (
            <p className="text-sm text-ink-2 mt-2" data-testid="search-did-you-mean">
              Did you mean <span className="font-medium text-brand">{data.corrected}</span>?
            </p>
          )}
          <p className="text-xs font-mono text-ink-2 mt-2" data-testid="search-count">{data.total} RESULT(S)</p>
          {data.items.length === 0 ? (
            <div className="text-center py-20" data-testid="search-no-results">
              <p className="text-ink-2">We could not find that. Try a category below, or tell us what you are looking for.</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6" data-testid="search-grid">
              {data.items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
            </div>
          )}
        </>
      )}
    </div>
  );
}
